// 関連ファイル処理
$(() => {
    $(document).on('change', '.js-deliverable-file', function(){
        // 最大アップロードファイルサイズ
        const maxFileSize = 10485760;
        const maxFileSizeStr = '10MB';
        // 既にアップロードエラーメッセージが表示されている場合は一旦削除
        $('#deliverable-file-errors').find('.upload-error').remove();
        $('#deliverable-file-upload-form').removeClass('form-control').removeClass('is-invalid');

        // アップロードファイルの取得
        let fileEntity = $(this)[0].files[0];
        let error = '';
        if (fileEntity === undefined) {
            error = 'ファイルのアップロードに失敗しました。再度お試しください。';
        } else if (fileEntity.size > maxFileSize) {
            error = 'アップロードファイルのサイズが最大値を超えました。最大アップロードサイズ：' + maxFileSizeStr;
        }

        if (error.length > 0) {
            $('#deliverable-file-errors').append('<span class="invalid-feedback upload-error" role="alert"><strong>' + error + '</strong>');
            $('#deliverable-file-upload-form').addClass('form-control').addClass('is-invalid');
            $(this).val("");
            return;
        }
    });
    $(document).on('click', '.js-remove-deliverables', function(){
        // 表示も削除
        $(this).parent().remove();
    });
});